export default __webpack_public_path__ + "static/media/IMG-20240708-WA0005.ef32e0f1.jpg";